import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareCapacityClassicEmbedRoute: InvariantJiraRoute = {
	name: 'software-capacity-classic-embed',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/capacity/embed',
};
